import React, { useEffect, useState } from 'react';
import {
  DEFAULT_MODEL_IMAGE_FRAME,
  modelImageFrameStyle,
  normalizeModelImageFrame,
  type AutomobileModelImageFrame,
} from '../../utils/automobileModelImageFrame';

type Props = {
  src: string;
  alt?: string;
  frame?: Partial<AutomobileModelImageFrame> | null;
  className?: string;
  onError?: () => void;
};

const AutomobileBrandLogoImage: React.FC<Props> = ({
  src,
  alt = '',
  frame,
  className = '',
  onError,
}) => {
  const [failed, setFailed] = useState(false);
  const resolvedFrame = normalizeModelImageFrame(frame ?? DEFAULT_MODEL_IMAGE_FRAME);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) return null;

  return (
    <img
      key={src}
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={`w-full h-full object-contain object-center ${className}`}
      style={modelImageFrameStyle(resolvedFrame)}
      onError={() => {
        setFailed(true);
        onError?.();
      }}
    />
  );
};

export default AutomobileBrandLogoImage;
